import React, { createContext, useContext, useState, useEffect } from "react";

const translations = {
  it: {
    nav: {
      home: "Home",
      catalog: "Catalogo",
      categories: "Categorie",
      wishlist: "Preferiti",
      cart: "Carrello",
      about: "La storia di OBI",
      gift: "Regalo perfetto",
      search_placeholder: "Cerca giochi...",
    },
    home: {
      hero_eyebrow: "Bottega di Nalise",
      hero_pretitle: "Giochi da tavolo",
      hero_title_1: "Vi tratteremo",
      hero_title_2: "da cani",
      hero_title_3: "ma non ve ne pentirete!",
      hero_subtitle: "Avventure, risate e momenti indimenticabili. La nostra mascotte OBI ti guida tra centinaia di giochi per ogni età.",
      cta_shop: "Esplora il catalogo",
      cta_secondary: "Le nostre categorie",
      featured_title: "Giochi in evidenza",
      featured_subtitle: "I preferiti di OBI questa settimana",
      categories_title: "Sfoglia per categoria",
      categories_subtitle: "Trova il gioco perfetto per ogni momento",
      benefit_1_title: "Spedizione veloce",
      benefit_1_text: "Pronti a giocare in 24-48h",
      benefit_2_title: "Pagamenti sicuri",
      benefit_2_text: "PayPal e bonifico",
      benefit_3_title: "Consigli da esperti",
      benefit_3_text: "Scegliamo solo giochi che amiamo",
      newsletter_title: "Ricevi sconti e novità",
      newsletter_subtitle: "Iscriviti alla newsletter di OBI",
      newsletter_btn: "Iscriviti",
      obi_title: "I giochi consigliati da OBI",
      obi_subtitle: "Tre giochi che OBI ha già provato (annusato!) e approvato",
      obi_badge: "Recensito da OBI",
      obi_loading: "OBI sta scrivendo la recensione...",
    },
    catalog: {
      title: "Tutti i giochi",
      filters: "Filtri",
      sort: "Ordina",
      sort_new: "Più recenti",
      sort_price_asc: "Prezzo crescente",
      sort_price_desc: "Prezzo decrescente",
      sort_popular: "Più popolari",
      price_range: "Fascia di prezzo",
      categories: "Categorie",
      reset_filters: "Azzera filtri",
      no_results: "Nessun gioco trovato",
      no_results_sub: "Prova con un altro filtro o cerca un titolo diverso.",
      results_count: "risultati",
    },
    product: {
      add_to_cart: "Aggiungi al carrello",
      add_to_wishlist: "Aggiungi ai preferiti",
      remove_from_wishlist: "Rimuovi dai preferiti",
      in_stock: "Disponibile",
      out_of_stock: "Esaurito",
      quantity: "Quantità",
      description: "Descrizione",
      details: "Dettagli",
      shipping: "Spedizione",
      shipping_text: "Spedizione in 24-48h. Reso facile entro 14 giorni.",
      related: "Potrebbe piacerti anche",
      from: "a partire da",
    },
    gpsr: {
      section_title: "Informazioni di sicurezza prodotto",
      section_subtitle: "Reg. UE 2023/988 (GPSR)",
      brand: "Marchio",
      manufacturer: "Produttore",
      eu_responsible: "Responsabile UE",
      same_as_manufacturer: "(coincide con il produttore)",
      address: "Indirizzo",
      vat: "P.IVA / VAT",
      email: "Email",
      phone: "Telefono",
      website: "Sito web",
      warnings: "Avvertenze di sicurezza",
      placeholder_notice: "I dati di questo marchio sono in fase di completamento. Per informazioni complete, contatta il venditore.",
    },
    cart: {
      title: "Il tuo carrello",
      empty: "Il tuo carrello è vuoto",
      empty_sub: "OBI non vede l'ora di farti scoprire i nostri giochi!",
      continue_shopping: "Continua lo shopping",
      subtotal: "Totale parziale",
      checkout: "Vai alla cassa",
      remove: "Rimuovi",
      qty: "Q.tà",
    },
    checkout: {
      title: "Cassa",
      contact: "Contatti",
      email: "Email",
      phone: "Telefono",
      billing: "Indirizzo di fatturazione",
      shipping: "Indirizzo di spedizione",
      same_as_billing: "Spedisci allo stesso indirizzo",
      first_name: "Nome",
      last_name: "Cognome",
      address_1: "Indirizzo",
      address_2: "Interno, scala (opzionale)",
      city: "Città",
      state: "Provincia",
      postcode: "CAP",
      country: "Paese",
      notes: "Note per l'ordine (opzionale)",
      gift_wrap: "Confezione regalo (gratuita)",
      gift_note: "CONFEZIONE REGALO RICHIESTA",
      payment: "Pagamento",
      payment_paypal: "Pagamento con PayPal",
      payment_note: "Completerai il pagamento in sicurezza sul nostro sito WooCommerce.",
      summary: "Riepilogo ordine",
      total: "Totale",
      submit: "Procedi al pagamento",
      submitting: "Sto creando l'ordine...",
      back_to_cart: "Torna al carrello",
      error: "Si è verificato un errore. Riprova.",
    },
    wishlist: {
      title: "I tuoi preferiti",
      empty: "Nessun preferito ancora",
      empty_sub: "Tocca il cuore sui giochi che ami per salvarli qui.",
    },
    footer: {
      about_title: "Bottega di Nalise",
      about_text: "Giochi da tavolo selezionati con amore. La nostra mascotte OBI assaggia... ehm, prova tutti i giochi prima di consigliarteli!",
      links_title: "Link utili",
      contact_title: "Contatti",
      newsletter_title: "Newsletter",
      newsletter_text: "Ricevi le novità di OBI direttamente in posta.",
      rights: "Tutti i diritti riservati",
    },
    common: {
      loading: "Caricamento...",
      currency: "€",
      free: "Gratis",
    },
    chat: {
      title: "Chiedi a OBI",
      subtitle: "Il tuo consulente con la coda scodinzolante",
      placeholder: "Scrivi un messaggio a OBI...",
      send: "Invia",
      welcome: "Bau! Sono OBI 🐾 Posso aiutarti a scegliere il gioco perfetto. Dimmi quante persone sarete, l'età o cosa vi piace!",
      quick_1: "Gioco per 4 in 30 minuti",
      quick_2: "Per bambini di 8 anni",
      quick_3: "Strategico cooperativo",
      open: "Chiedi a OBI",
      thinking: "OBI sta scodinzolando...",
      clear: "Nuova chat",
    },
    gift: {
      hero_eyebrow: "Servizio regalo OBI",
      hero_title: "Trova il regalo perfetto",
      hero_subtitle: "Rispondi a 4 domande veloci e OBI sceglie 3 giochi su misura per chi vuoi sorprendere.",
      cta_start: "Inizia",
      step: "Passo",
      of: "di",
      q1: "Per quale occasione?",
      q1_options: ["Compleanno", "Natale", "Anniversario", "Festa dei papà/mamma", "Solo perché sì", "Altra occasione"],
      q2: "Che età ha chi riceve il regalo?",
      q2_options: ["3-6 anni", "7-10 anni", "11-14 anni", "15-18 anni", "Adulti", "Famiglia mista"],
      q3: "Quanto vuoi spendere?",
      q3_options: ["Fino a 20€", "20-40€", "40-70€", "70-100€", "Oltre 100€", "Nessun limite"],
      q4: "Che tipo di gioco preferisce?",
      q4_placeholder: "Es: strategici, party game, cooperativi, avventura, giochi di carte, ride molto, ama pensare...",
      submit: "Trova il regalo!",
      thinking: "OBI sta annusando il catalogo...",
      results_title: "I 3 giochi scelti da OBI",
      try_again: "Riprova con altre risposte",
      empty_catalog: "Il negozio sta facendo rifornimento. Torna presto!",
      view_product: "Scopri",
    },
    notfound: {
      title: "Pagina smarrita!",
      sub: "OBI ha cercato dappertutto ma non ha trovato questa pagina.",
      cta: "Torna alla home",
    },
    about: {
      hero_eyebrow: "La nostra storia",
      hero_title: "Ciao, sono OBI 🐾",
      hero_subtitle: "Golden retriever adulto color panna, capo annusatore della Bottega di Nalise.",
      chapter1_title: "Tutto è iniziato con un dado",
      chapter1_text: "Da cucciolo non capivo perché Nalise passasse tante serate ridendo davanti a scatole colorate piene di pedine, carte e dadi. Poi un giorno un dado mi è rotolato vicino alla cuccia… l'ho annusato, l'ho leccato (scusa Nalise!) e da quel momento sono diventato il giudice ufficiale di ogni gioco che entra in casa.",
      chapter2_title: "Il mio mestiere oggi",
      chapter2_text: "Adesso Nalise ha aperto la Bottega e io ho un compito serissimo: provare ogni gioco prima che arrivi a te. Annuso la scatola, ascolto le regole, scodinzolo durante le partite di prova e — solo se passa il test della coda — quel gioco finisce sugli scaffali.",
      chapter3_title: "Cosa cerchiamo",
      chapter3_text: "Non vendiamo TUTTI i giochi del mondo. Scegliamo quelli che ci fanno ridere, ci fanno pensare, ci uniscono con amici e famiglia. Strategici, party, cooperativi, per bambini: ognuno selezionato da me e Nalise, con le zampe e con il cuore.",
      values_title: "I valori della Bottega",
      value1_title: "Qualità prima di tutto",
      value1_text: "Ogni gioco è testato. Se non piace nemmeno a me, non lo troverai qui.",
      value2_title: "Consigli sinceri",
      value2_text: "Niente vendita forzata. Ti diciamo onestamente cosa ti piacerà.",
      value3_title: "Cuore italiano",
      value3_text: "Spediamo dall'Italia, parliamo italiano, sosteniamo gli editori locali.",
      cta_title: "Vieni a fare una partita con noi",
      cta_subtitle: "OBI ti aspetta con la coda già in modalità scodinzolo.",
      cta_button: "Esplora il catalogo",
    },
  },
  en: {
    nav: {
      home: "Home",
      catalog: "Catalog",
      categories: "Categories",
      wishlist: "Wishlist",
      cart: "Cart",
      about: "OBI's story",
      gift: "Perfect gift",
      search_placeholder: "Search games...",
    },
    home: {
      hero_eyebrow: "Bottega di Nalise",
      hero_pretitle: "Board games",
      hero_title_1: "We'll spoil you",
      hero_title_2: "like puppies",
      hero_title_3: "and you'll love every minute!",
      hero_subtitle: "Adventures, laughs and unforgettable moments. Our mascot OBI guides you through hundreds of games for every age.",
      cta_shop: "Browse catalog",
      cta_secondary: "Our categories",
      featured_title: "Featured games",
      featured_subtitle: "OBI's favorites this week",
      categories_title: "Shop by category",
      categories_subtitle: "Find the perfect game for any moment",
      benefit_1_title: "Fast shipping",
      benefit_1_text: "Ready to play in 24-48h",
      benefit_2_title: "Secure payments",
      benefit_2_text: "PayPal and bank transfer",
      benefit_3_title: "Expert advice",
      benefit_3_text: "We only pick games we love",
      newsletter_title: "Get deals & news",
      newsletter_subtitle: "Subscribe to OBI's newsletter",
      newsletter_btn: "Subscribe",
      obi_title: "OBI's picks",
      obi_subtitle: "Three games OBI has tried (and sniffed!) and approved",
      obi_badge: "Reviewed by OBI",
      obi_loading: "OBI is writing the review...",
    },
    catalog: {
      title: "All games",
      filters: "Filters",
      sort: "Sort",
      sort_new: "Newest",
      sort_price_asc: "Price low to high",
      sort_price_desc: "Price high to low",
      sort_popular: "Most popular",
      price_range: "Price range",
      categories: "Categories",
      reset_filters: "Reset filters",
      no_results: "No games found",
      no_results_sub: "Try a different filter or search keyword.",
      results_count: "results",
    },
    product: {
      add_to_cart: "Add to cart",
      add_to_wishlist: "Add to wishlist",
      remove_from_wishlist: "Remove from wishlist",
      in_stock: "In stock",
      out_of_stock: "Out of stock",
      quantity: "Quantity",
      description: "Description",
      details: "Details",
      shipping: "Shipping",
      shipping_text: "Ships in 24-48h. Easy returns within 14 days.",
      related: "You may also like",
      from: "from",
    },
    gpsr: {
      section_title: "Product safety information",
      section_subtitle: "EU Reg. 2023/988 (GPSR)",
      brand: "Brand",
      manufacturer: "Manufacturer",
      eu_responsible: "EU Responsible Person",
      same_as_manufacturer: "(same as manufacturer)",
      address: "Address",
      vat: "VAT",
      email: "Email",
      phone: "Phone",
      website: "Website",
      warnings: "Safety warnings",
      placeholder_notice: "Data for this brand is being completed. For full information, please contact the seller.",
    },
    cart: {
      title: "Your cart",
      empty: "Your cart is empty",
      empty_sub: "OBI can't wait to show you our games!",
      continue_shopping: "Continue shopping",
      subtotal: "Subtotal",
      checkout: "Go to checkout",
      remove: "Remove",
      qty: "Qty",
    },
    checkout: {
      title: "Checkout",
      contact: "Contact",
      email: "Email",
      phone: "Phone",
      billing: "Billing address",
      shipping: "Shipping address",
      same_as_billing: "Ship to billing address",
      first_name: "First name",
      last_name: "Last name",
      address_1: "Address",
      address_2: "Apartment, floor (optional)",
      city: "City",
      state: "State / Province",
      postcode: "Postcode",
      country: "Country",
      notes: "Order notes (optional)",
      gift_wrap: "Gift wrap (free)",
      gift_note: "GIFT WRAP REQUESTED",
      payment: "Payment",
      payment_paypal: "Pay with PayPal",
      payment_note: "You will securely complete payment on our WooCommerce site.",
      summary: "Order summary",
      total: "Total",
      submit: "Proceed to payment",
      submitting: "Creating order...",
      back_to_cart: "Back to cart",
      error: "Something went wrong. Please try again.",
    },
    wishlist: {
      title: "Your wishlist",
      empty: "No favorites yet",
      empty_sub: "Tap the heart on games you love to save them here.",
    },
    footer: {
      about_title: "Bottega di Nalise",
      about_text: "Hand-picked board games. Our mascot OBI tastes... err, tries every game before recommending it!",
      links_title: "Useful links",
      contact_title: "Contact",
      newsletter_title: "Newsletter",
      newsletter_text: "Get OBI's news straight to your inbox.",
      rights: "All rights reserved",
    },
    common: {
      loading: "Loading...",
      currency: "€",
      free: "Free",
    },
    chat: {
      title: "Ask OBI",
      subtitle: "Your tail-wagging consultant",
      placeholder: "Write a message to OBI...",
      send: "Send",
      welcome: "Woof! I'm OBI 🐾 I can help you pick the perfect game. Tell me how many of you, the ages, or what you like!",
      quick_1: "Game for 4 in 30 minutes",
      quick_2: "For 8-year-old kids",
      quick_3: "Cooperative strategy",
      open: "Ask OBI",
      thinking: "OBI is wagging tail...",
      clear: "New chat",
    },
    gift: {
      hero_eyebrow: "OBI gift service",
      hero_title: "Find the perfect gift",
      hero_subtitle: "Answer 4 quick questions and OBI picks 3 games tailored to whoever you want to surprise.",
      cta_start: "Start",
      step: "Step",
      of: "of",
      q1: "What's the occasion?",
      q1_options: ["Birthday", "Christmas", "Anniversary", "Father's/Mother's day", "Just because", "Other"],
      q2: "How old is the recipient?",
      q2_options: ["3-6 years", "7-10 years", "11-14 years", "15-18 years", "Adults", "Mixed family"],
      q3: "What's your budget?",
      q3_options: ["Up to €20", "€20-40", "€40-70", "€70-100", "Over €100", "No limit"],
      q4: "What kind of game do they like?",
      q4_placeholder: "E.g.: strategy, party games, cooperative, adventure, card games, love to laugh, love to think...",
      submit: "Find the gift!",
      thinking: "OBI is sniffing the catalog...",
      results_title: "OBI's 3 picks for you",
      try_again: "Try with different answers",
      empty_catalog: "The store is restocking. Come back soon!",
      view_product: "View",
    },
    notfound: {
      title: "Page lost!",
      sub: "OBI looked everywhere but couldn't find this page.",
      cta: "Back home",
    },
    about: {
      hero_eyebrow: "Our story",
      hero_title: "Hi, I'm OBI 🐾",
      hero_subtitle: "Adult cream golden retriever, chief sniffer of Bottega di Nalise.",
      chapter1_title: "It all started with a dice",
      chapter1_text: "As a puppy I didn't understand why Nalise spent so many evenings laughing in front of colorful boxes full of pawns, cards and dice. Then one day a dice rolled near my bed… I sniffed it, I licked it (sorry Nalise!) and from that moment I became the official judge of every game that enters the house.",
      chapter2_title: "My job today",
      chapter2_text: "Now Nalise has opened the Bottega and I have a very serious task: I test every game before it reaches you. I sniff the box, listen to the rules, wag my tail through the test games — and only if it passes the tail-wag test does the game make it to the shelves.",
      chapter3_title: "What we look for",
      chapter3_text: "We don't sell EVERY game in the world. We pick the ones that make us laugh, make us think, bring us together with friends and family. Strategy, party, cooperative, kids: each one selected by Nalise and me, with paws and heart.",
      values_title: "Our values",
      value1_title: "Quality first",
      value1_text: "Every game is tested. If I don't like it, you won't find it here.",
      value2_title: "Honest advice",
      value2_text: "No hard selling. We tell you honestly what you'll love.",
      value3_title: "Italian heart",
      value3_text: "We ship from Italy, we speak Italian, we support local publishers.",
      cta_title: "Come play a game with us",
      cta_subtitle: "OBI is waiting, tail already in wag-mode.",
      cta_button: "Browse catalog",
    },
  },
};

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("nalise_lang") || "it");

  useEffect(() => {
    localStorage.setItem("nalise_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (path) => {
    const keys = path.split(".");
    let current = translations[lang];
    for (const k of keys) {
      if (current && typeof current === "object" && k in current) current = current[k];
      else return path;
    }
    return current;
  };

  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be used within LangProvider");
  return ctx;
};
